import { IRootState } from '../../../store'
import { ITitrateOptionsState } from '../store/options.types'

export const getTitrateOptionsSelector = (state: IRootState): ITitrateOptionsState => state.options.titrateOptions
